import { Injectable } from '@angular/core';
import { Router, NavigationEnd, UrlTree, PRIMARY_OUTLET, UrlSegmentGroup, UrlSegment } from '@angular/router';
import { LastSeenTurbinesGQL } from '../data-services/graphql';
import { filter, map, take } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { ObjectUtil } from 'app/utils/object.util';

@Injectable({
  providedIn: 'root'
})
export class LastSeenTurbinesService {

  private lastSeenTurbines: any[] = [];
  public lastSeenTurbines$ = new BehaviorSubject([]);

  constructor(
    private router: Router,
    private lastSeenTurbinesGQL: LastSeenTurbinesGQL
  ) { }

  public startTracking() {
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        const tree: UrlTree = this.router.parseUrl(val.url);
        const g: UrlSegmentGroup = tree.root.children[PRIMARY_OUTLET];
        const s: UrlSegment[] = g ? g.segments : [];
        const segments = s.map(segment => segment.path);
        const index = segments.findIndex(segment => segment === 'turbine');
        if (segments[index] === 'turbine') {
          if (segments[index + 1]) {
            const turbineObservable = this.lastSeenTurbinesGQL.watch({
              variables: { serialNav: parseInt(segments[index + 1], 10) }
            }).valueChanges.pipe(
              filter(a => !a.loading),
              map(result => {
                return result.data.turbines[0]
              })
            );
            turbineObservable.pipe(
              take(1)
            ).subscribe(data => this.addTurbine(data));
          }
        }
      }
    });
  }

  public addTurbine(data: any) {
    if (data) {
      this.lastSeenTurbines.unshift(Object.assign({
        code: data.code,
        serialNav: data.serialNav,
        WTUR1_status: ObjectUtil.getProperty(data, 'data.WTUR1_status', 0)
      }));
      this.lastSeenTurbines = this.lastSeenTurbines.slice(0, 5);
      this.lastSeenTurbines$.next(this.lastSeenTurbines);
    }
  }

}
